import { apiAuth, apiResponseType } from ".";

export const getSelectSaleTypes = () =>
  apiAuth.get(`sale-types/select`) as apiResponseType;
